<template>
    <span class="text-danger">
        <i
            class="fa fa-trash fa-lg icon-button"
            title="Desassociar Serviço"
            @click.stop="
                confirmarDesassociar(
                    pagamentoComprometimento.pagamentoComprometimentoId
                )
            "
        ></i>
    </span>
</template>

<script>
export default {
    props: {
        pagamento: {
            type: Object,
            default: () => ({})
        },

        pagamentoComprometimento: {
            type: Object,
            default: () => ({})
        },

        pagamentosServicos: {
            type: Object,
            default: () => ({})
        }
    },

    data() {
        return {}
    },

    methods: {
        confirmarDesassociar(pagamentoComprometimentoId) {
            this.$swal({
                title: 'Desassociação do Serviço',
                html: `Confirma a desassociação do serviço?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.desassociar(pagamentoComprometimentoId)
                }
            })
        },

        desassociar(pagamentoComprometimentoId) {
            this.$store.dispatch('addRequest')
            this.pagamentosServicos
                .desassociarComprometimento({
                    pagamentoId: this.$route.params.pagamentoId,
                    pagamentoComprometimentoId: pagamentoComprometimentoId
                })
                .then(response => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Serviço desassociado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterPagamentoAtualizado')
                        } else {
                            this.$toast.error(
                                'Erro ao desassociar serviço do pagamento.',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {}
}
</script>
